module.exports = __webpack_public_path__ + "assets/img/sixin.2195ea50.png";